import { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// scroll ile ortaya çıkma: sadece opaklık + küçük dikey kayma, 400–750ms
export function useReveal(ready = true) {
  useEffect(() => {
    if (!ready) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      gsap.utils.toArray(".bel").forEach((el) => gsap.set(el, { opacity: 1, y: 0 }));
      return;
    }
    const ctx = gsap.context(() => {
      gsap.utils.toArray(".bel").forEach((el) => {
        gsap.to(el, {
          opacity: 1, y: 0, duration: 0.75, ease: "power2.out",
          scrollTrigger: { trigger: el, start: "top 88%" },
        });
      });
    });
    const t = setTimeout(() => ScrollTrigger.refresh(), 150);
    return () => { clearTimeout(t); ctx.revert(); };
  }, [ready]);
}

export { gsap, ScrollTrigger };
